import { NavLink } from 'react-router-dom';
import { LayoutDashboard, TrendingUp, Flag, Settings } from 'lucide-react';
import { useApp } from '../context/AppContext';

export default function Sidebar() {
  const { flaggedItems } = useApp();
  const flaggedCount = flaggedItems.length;
  return (
    <nav className="sidebar">
      <div className="sidebar-nav">
        <NavLink
          to="/workflows"
          className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
        >
          <LayoutDashboard size={18} />
          <span className="sidebar-tooltip">Workflows</span>
        </NavLink>
        <NavLink
          to="/roi"
          className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
        >
          <TrendingUp size={18} />
          <span className="sidebar-tooltip">ROI</span>
        </NavLink>
        <NavLink
          to="/flagged"
          className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
        >
          <Flag size={18} />
          <span className="sidebar-tooltip">Flagged Reviews</span>
          {flaggedCount > 0 && <span className="sidebar-badge">{flaggedCount}</span>}
        </NavLink>
        <NavLink
          to="/settings"
          className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
        >
          <Settings size={18} />
          <span className="sidebar-tooltip">Settings</span>
        </NavLink>
      </div>
    </nav>
  );
}
